exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".o-LastActivity .o-SliderHorizontal__list {\n  margin: 0; }\n\n@media screen and (min-width: 45em) {\n  .o-LastActivity .tns-item {\n    max-width: 33.33333%; } }\n", ""]);

// exports
